/* KS Ajax-varukorg (Kunskapstavlan 2026-11-01). Formulär med data-ks-ajax-cart, data-ks-su-form (KS Sellup-produkt) eller
   klassen ks-pr__form (KS Produkter) läggs i varukorgen utan sidladdning och temats varukorgslåda (cart-drawer) öppnas.
   Laddas från snippets/cart-drawer.liquid på alla sidor. Faller tillbaka till vanlig formulärsändning om något saknas. */
(function () {
  if (window.__ksAjaxCart) return;
  window.__ksAjaxCart = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.hasAttribute) return;
    // Gäller formulär märkta data-ks-ajax-cart samt KS Sellup-produkt (data-ks-su-form) och KS Produkter (.ks-pr__form)
    if (!f.hasAttribute('data-ks-ajax-cart') && !f.hasAttribute('data-ks-su-form') && !f.classList.contains('ks-pr__form')) return;
    var d = document.querySelector('cart-drawer');
    if (!d || typeof d.renderContents !== 'function' || !window.fetch || !window.FormData) return;
    e.preventDefault();
    var btn = f.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(f);
    fd.delete('return_to');
    if (typeof d.getSectionsToRender === 'function') {
      try {
        fd.append('sections', d.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        fd.append('sections_url', window.location.pathname);
      } catch (err) {}
    }
    var base = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(base + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status) throw new Error(j.description || j.message || 'error');
        d.renderContents(j);
        if (window.publish && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ks-ajax-cart', productVariantId: j.variant_id, cartData: j }); } catch (err) {}
        }
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      })
      .catch(function () {
        f.removeAttribute('data-ks-ajax-cart'); f.removeAttribute('data-ks-su-form'); f.classList.remove('ks-pr__form');
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        f.submit();
      });
  }, true);
})();
